// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"7d5d9a61","405":"580ec09b","453":"7691b22d","748":"810e10c5","996":"acc021c4"}[chunkId] + ".chunk.js";
};